// Define what styled components base-theme will look like
const theme = {
  breakpoints: {
    verySmall: '330px',
    small: '460px',
    med: '660px',
    large: '960px',
    largeMax: '1019px',
    max: '1025px',
  },
  fontFamily: {
    primary: 'rooney-sans, sans-serif',
  },
  colors: {
    primary: '#FFF',
    background: '#000',
    backgroundLighter1: '#313131',
    positive: '#59AC51',
    negative: '#C75555',
    accent1: '#fff989',
    twitter: '#55acee',
    facebook: '#3B5998',
    grey: '#e2e2e2',
    greyLight: '#eee',
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js